import React from "react";
import HeroBottomSection from "../../medias/heroButtomImg.png";

const ariTestimonial = {
  quote: 'CustomSync has helped us save countless hours every week by automating our Amazon/Etsy custom workflow. The founder Nick is quick to respond, detail-oriented, and just really great to work with.',
  author: 'Ari',
  company: 'Monjo',
  companyUrl: 'https://www.linkedin.com/company/monjo-co/',
  highlight: 'save countless hours',
  logo: '/images/testimonials/monjo_co_logo.jpeg',
};

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#FACC14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-yellow-400" aria-hidden="true">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const BannerFbAd = () => {
  const t = ariTestimonial;
  const [quoteStart, quoteEnd] = t.quote.split(t.highlight);

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-x-0 top-0 min-h-[800px] bg-gradient-to-b from-[#3B79B3] to-[#19344D]" />

      <div className="relative overflow-hidden">
        <div className="mx-auto max-w-4xl px-6 sm:px-10 lg:px-10 pt-12 md:pt-16 pb-20 text-center">
          <p className="text-[16px] md:text-[18px] lg:text-[20px] text-white/90 max-w-2xl mx-auto mb-2">
            <span className="relative inline-block px-2">
              BUILT
              <svg className="absolute left-0 bottom-[-3px] w-full h-[10px] text-[#F29E13]" viewBox="242 259 180 35" fill="none" stroke="currentColor" strokeWidth="6">
                <path d="m242,292.5c0,0 70,-33 180,-19" />
              </svg>
            </span>
            {''}for <span className="text-[#F29E13]">Amazon Custom</span> and{' '}
            <span className="text-[#F29E13]">Handmade</span> sellers.
          </p>

          <h1 className="text-white font-bold text-[32px] leading-[42px] sm:text-[40px] sm:leading-[50px] md:text-[48px] md:leading-[58px] lg:text-[58px] lg:leading-[64px] mb-6">
            Stop copying and pasting Amazon Custom Orders.
            <br />
            <span className="text-[#F29E13]">Save 20+</span> hours every week.
          </h1>
          <p className="text-[18px] sm:text-[20px] md:text-[22px] lg:text-[26px] text-white/90 max-w-2xl mx-auto mb-8">
            CustomSync sends <span className="text-[#F29E13]">Amazon</span> order customization{' '}
            <span className="text-[#F29E13]">text</span> and <span className="text-[#F29E13]">images</span> directly
            to ShipStation or Veeqo.
          </p>

          <a href="https://customsync.app/login?signup=true" className="inline-block">
            <div className="cursor-pointer bg-[#F29E13] px-10 py-4 rounded-lg font-bold text-white text-xl md:text-xl lg:text-2xl orange-button w-fit mx-auto">
              Start Your Free Trial in Minutes
            </div>
          </a>

          <figure className="mt-6 mx-auto max-w-xl rounded-2xl border border-gray-200 bg-stone-50 p-6 text-base leading-7 shadow transition-shadow duration-300 hover:shadow-lg text-left">
            <blockquote className="text-stone-900">
              <p>
                &ldquo;{quoteStart}
                <span className="bg-amber-100 font-medium text-stone-900">{t.highlight}</span>
                {quoteEnd}&rdquo;
              </p>
            </blockquote>
            <figcaption className="mt-6 flex items-start gap-4">
              <a href={t.companyUrl} target="_blank" rel="noopener noreferrer" className="flex-shrink-0">
                <img src={t.logo} alt={`${t.company} logo`} className="h-20 w-20 rounded-full object-cover shadow-md hover:opacity-80 transition-opacity cursor-pointer" />
              </a>
              <div className="flex flex-col flex-1">
                <span className="font-semibold text-stone-900">{t.author}</span>
                <a href={t.companyUrl} target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-stone-500 hover:underline">
                  {t.company}
                </a>
                <div className="mt-3 flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon key={i} />
                  ))}
                </div>
              </div>
            </figcaption>
          </figure>
        </div>
        <img
          className="relative mx-auto w-full max-w-5xl px-6 lg:px-0"
          src={HeroBottomSection}
          alt="CustomSync features preview"
        />
      </div>
    </div>
  );
};

export default BannerFbAd;
